import styled from 'styled-components';
import { useState } from 'react';
import WegetSidebar from './weget-sidebar';
import { WegetIframePanel } from './weget-iframe-panel';
import { useQueryParamsHook } from '../../../utils/useQueryParamsHook';
import { findRelatedServiceByKey, parseOpenServiceKeys } from '../variables/related-services';

const StyledContainer = styled.div`
  display: flex;
  min-height: 100vh;
`

const MainContent = styled.main`
  flex: 1;
  min-width: 0;
  height: 100vh;
  overflow-y: auto;
`

export function Layout(props) {
    const queryParamsHook = useQueryParamsHook();
    const [sidebarForceOpen, setSidebarForceOpen] = useState(false);

    const openKeys = parseOpenServiceKeys(queryParamsHook?.params?.panels);
    const openServices = openKeys.map(findRelatedServiceByKey).filter(Boolean);
    const panelVisible = openServices.length > 0;

    const activeKeyParam = queryParamsHook?.params?.activePanel;
    const activeKey = openKeys.includes(activeKeyParam) ? activeKeyParam : openKeys[0];

    // 패널이 열려 있으면 기본적으로 사이드바를 닫는다. (사용자가 다시 연 경우는 예외)
    const sidebarVisible = !panelVisible || sidebarForceOpen;

    const applyPanels = (nextKeys, nextActiveKey) => {
        const nextParams = { ...queryParamsHook.params };
        if (nextKeys.length === 0) {
            delete nextParams.panels;
            delete nextParams.activePanel;
            setSidebarForceOpen(false);
        } else {
            nextParams.panels = nextKeys.join(',');
            nextParams.activePanel = nextKeys.includes(nextActiveKey) ? nextActiveKey : nextKeys[0];
        }
        queryParamsHook.setSearchParams(nextParams, { replace: true });
    };

    const handleSelectTab = (key) => {
        applyPanels(openKeys, key);
    };

    const handleCloseTab = (key) => {
        const closedIndex = openKeys.indexOf(key);
        const nextKeys = openKeys.filter(k => k !== key);

        let nextActiveKey = activeKey;
        if (key === activeKey) {
            // 닫은 탭이 활성 탭이면 인접 탭으로 활성 이동
            nextActiveKey = nextKeys[closedIndex] || nextKeys[closedIndex - 1] || nextKeys[0];
        }

        applyPanels(nextKeys, nextActiveKey);
    };

    return (
        <>
            <StyledContainer>
                {sidebarVisible && <WegetSidebar />}
                <MainContent>
                    {props.children}
                </MainContent>
                {panelVisible && (
                    <WegetIframePanel
                        services={openServices}
                        activeKey={activeKey}
                        sidebarVisible={sidebarVisible}
                        onSelectTab={handleSelectTab}
                        onCloseTab={handleCloseTab}
                        onToggleSidebar={() => setSidebarForceOpen(prev => !prev)}
                    />
                )}
            </StyledContainer>
        </>
    );
}
